module.exports = __webpack_public_path__ + "img/IMG_0459_FoamcoreMatted.08a1a889.jpg";